var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-loading",style:(Object.assign({}, {'height': _vm.height, 'width': _vm.width}, _vm.additionalStyle))})}
var staticRenderFns = []

export { render, staticRenderFns }